;(function() {
  'use strict'

  angular.module('core.sidenav', [])
})()
